!((window, document, $) => {
	/* Just cancel if we're in the admin portal */
	if (document.body.classList.contains("wp-admin")) {
		return;
	}

	const search_toggle_class = ".right-nav-links__search .theme-header__global-nav-toggle";
	const search_open_class = ".search-open";
	const search_close_class = ".search-close";
	const search_elm_class = ".theme-header__global-search-filter";

	const search_toggle_elm = document.querySelector(search_toggle_class);
	const search_elm = document.querySelector(search_elm_class);
	const search_elm_open = document.querySelector(search_open_class);
	const search_elm_close = document.querySelector(search_close_class);

	/**
	 * @description Helper function to check if an element is visible on the screen.
	 * @param {HTMLElement} elem HTML dom element to check visibility against
	 * @return boolean
	 */
	const isVisible = (elem) =>
		!!elem && !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length); // source (2018-03-11): https://github.com/jquery/jquery/blob/master/src/css/hiddenVisibleSelectors.js

	/**
	 * @description Close the search bar from the navigation
	 * @return void
	 */
	const closeSearch = () => {
		search_elm.classList.add("nav-hide");
		search_elm_open.classList.remove("nav-hide");
		search_elm_close.classList.add("nav-hide");
		removeClickListener();
	};

	/**
	 * @description Open the search bar in the navigation
	 * @return void
	 */
	const openSearch = () => {
		search_elm.classList.toggle("nav-hide");
		search_elm_open.classList.toggle("nav-hide");
		search_elm_close.classList.toggle("nav-hide");

		document.addEventListener("click", outsideSearchClickListener);
	};

	/**
	 * @description Listener for clicks outside the navigation search bar, close if outside
	 * @listens click
	 * @param {Event} event HTML dom event
	 * @return void
	 */
	const outsideSearchClickListener = (event) => {
		if (!search_elm.contains(event.target)) {
			closeSearch();
		}
	};

	/**
	 * @description Cancel listener for clicks outside the navigation search bar
	 * @listens click
	 * @return void
	 */
	const removeClickListener = () => {
		document.removeEventListener("click", outsideSearchClickListener);
	};

	/**
	 * @description Listens for a click to open the navigation search bar
	 * @listens click
	 * @param {Event} event HTML dom event
	 * @return void
	 */
	search_toggle_elm.addEventListener("click", (event) => {
		event.stopPropagation();
		const isClickInside = search_elm.contains(event.target);

		if (!isVisible(search_elm)) {
			openSearch();
		} else if (isVisible(search_elm) && isVisible(search_elm_close)) {
			closeSearch();
		}
	});

	/* Code for the nav flyout on desktop */
	const nav_link_elms = document.querySelectorAll('[data-js-selector="nav-flyout-parent"]');
	const nav_shallow_link_elms = document.querySelectorAll(
		'.theme-nav__link:not([data-js-selector="nav-flyout-parent"])'
	);
	const nav_link_id_selector = "data-js-parent";
	const nav_link_id_data = "jsParent";
	const nav_flyout_elms = document.querySelectorAll('[data-js-selector="nav-flyout"]');
	const nav_flyout_id_prefix = "nav-flyout-";
	const nav_flyout_open_class = "d-none";

	/**
	 * @description Method for closing flyouts
	 * @param {Number} $flyoutId ID for the flyout element
	 * @return void
	 */
	const closeFlyout = ($flyoutId) => {
		const flyoutLink = document.getElementById(`[${nav_link_id_selector}="${$flyoutId}"]`);
		const flyout = document.getElementById(`${nav_flyout_id_prefix}${$flyoutId}`);

		flyout.classList.add(nav_flyout_open_class);
	};

	/**
	 * @description Method for opening flyouts
	 * @param {Event} triggeringEvent Event that triggered this method to be called
	 * @param {Number} $flyoutId ID for the flyout element
	 * @return void
	 */
	const openFlyout = (triggeringEvent, $flyoutId) => {
		// closeSearch();

		let target = triggeringEvent.target;
		let pos = target.getBoundingClientRect();

		const flyoutElm = document.getElementById(`${nav_flyout_id_prefix}${$flyoutId}`);
		flyoutElm.classList.toggle(nav_flyout_open_class);

		flyoutElm.style.left = `${pos.left - 80}px`;

		triggeringEvent.target.addEventListener("mouseleave", outsideMenuItemListener);
		triggeringEvent.target.addEventListener("blur", outsideMenuItemListener);
		flyoutElm.addEventListener("mouseleave", outsideMenuItemListener);
		flyoutElm.querySelectorAll("a").forEach((linkElm) => {
			linkElm.addEventListener("blur", outsideMenuItemListener);
		});
	};

	/**
	 * @description Method for clearing delays for closing flyouts
	 * @param {Event} event
	 * @return void
	 */
	const flyoutMenuItemListener = (event) => {
		// console.log('flyoutMenuItemListener: ', event)
	};

	/**
	 * @description Method for closing flyouts if the mouse has left the element or its relatives
	 * @param {Event} event Event that triggered this method
	 * @return void
	 */
	const outsideMenuItemListener = (event) => {
		const flyoutId = event.target.dataset[nav_link_id_data];
		const flyout = document.getElementById(`${nav_flyout_id_prefix}${flyoutId}`);

		if (window.matchMedia("screen and (min-width: 1000px)").matches) {
			if (
				event.type !== "blur" &&
				!event.relatedTarget.contains(event.target) &&
				!event.relatedTarget.contains(flyout)
			) {
				// console.log('not blur: ', event.toElement.contains(flyout))
				closeFlyout(flyoutId);
			}

			if (event.type === "blur" && !flyout.contains(event.relatedTarget)) {
				// console.log('blur: ');
				closeFlyout(flyoutId);
			}
		}
	};

	/**
	 * @description Listen to mouseenter on flyouts
	 * @param {HTMLElement} $flyoutElm Dom element for the flyout
	 * @return void
	 */
	nav_flyout_elms.forEach(($flyoutElm) => {
		$flyoutElm.addEventListener("mouseenter", flyoutMenuItemListener);
	});

	/**
	 * @description Listen to mouseenter on nav items that DO NOT have flyouts.
	 * This allows us to cancel opening a flyout if one was hovered for only a moment.
	 * @param {HTMLElement} $link Dom element for the nav links that don't have flyouts.
	 * @return void
	 */
	nav_shallow_link_elms.forEach(($link) => {
		$link.addEventListener("mouseenter", (event) => {
			// No timeout needed, it happens immediately.
		});
	});

	/**
	 * @description Listen to mouseenter on flyout nav items
	 * @param {HTMLElement} $link Dom element for the flyout trigger
	 * @return void
	 */
	nav_link_elms.forEach(($link) => {
		let open = (event) => {
			if (event.type === "keydown" && event.key !== "Enter") return;

			const id = $link.dataset[nav_link_id_data];

			openFlyout(event, id);
		};

		let close = (event) => {
			// No timeout needed, it happens immediately.
		};

		$link.addEventListener("mouseenter", open);
		$link.addEventListener("keydown", open);

		/* If the mouse leaves this flyout trigger. Cancel opening it. */
		$link.addEventListener("mouseleave", close);
	});
})(window, document, jQuery);
